import React from 'react'

import Container from '../Container'

const Events = ({ children }) => (
  <>
    <Container as="main">
      {children}
    </Container>
  </>
)

export default Events
